import { createApp } from 'vue'
import DatePicker from './components/DatePickerFilter.vue'

const datepickerElement = document.getElementById('c-date-picker')

if (datepickerElement) { 
    createApp(DatePicker, {
        hiddenInputId: datepickerElement.dataset.hiddenInputId, // ID to give the submitted hidden input field
        initialValue:  datepickerElement.dataset.initialValue,  // The date range value to pre-populate the date picker
    }).mount(datepickerElement)
}
